
import { defineComponent, PropType } from "vue";
import { IVatTuNgoaiDinhMuc } from "@/core/interfaces/ApiResponses";
import {
  calcLineAmount,
  formatAmount,
  formatQuantity,
  formatUnitPrice,
} from "@/core/helpers/number-format";
import useVatTu from "@/core/hooks/use-vat-tu";
import { usePagination } from "@/core/hooks/use-pagination";
import VatTuDetailModal from "@/components/vat-tu/VatTuDetailModal.vue";
import WordBreakColumn from "@/components/shared/work-break-column/WordBreakColumn.vue";
import { VAT_TU_TABLE_COLUMN_WIDTHS } from "@/components/shared/vat-tu-table/vat-tu-table-column-widths";
import Setting from "@/components/shared/setting/Setting.vue";
import type { SettingAction } from "@/components/shared/setting/Setting.vue";
import IconEye from "@/icons/IconEye.vue";
import IconTrash from "@/icons/IconTrash.vue";

export default defineComponent({
  name: "vat-tu-ngoai-dinh-muc-table-v2",

  emits: ["remove", "refresh"],

  components: {
    Setting,
    VatTuDetailModal,
    WordBreakColumn,
  },

  props: {
    curPage: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array as PropType<Array<IVatTuNgoaiDinhMuc>>,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    perPage: {
      type: Number,
      default: 0,
    },
    showPriceAndTotal: {
      type: Boolean,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const { indexCal } = usePagination();
    const { isValidLabel } = useVatTu();

    return {
      indexCal,
      isValidLabel,
    };
  },

  data() {
    return {
      columnWidths: VAT_TU_TABLE_COLUMN_WIDTHS,
      vatTuItems: this.items as IVatTuNgoaiDinhMuc[],
      selectedVatTuId: undefined as number | undefined,
    };
  },

  watch: {
    items(value) {
      this.vatTuItems = value;
    },
  },

  methods: {
    formatQuantity,
    formatUnitPrice,
    formatAmount,
    calcLineAmount,

    rowClassName({ row }: { row: IVatTuNgoaiDinhMuc }) {
      return row.is_valid === 0 ? "text-danger" : "";
    },

    getSettingActions(row: IVatTuNgoaiDinhMuc): SettingAction[] {
      const actions: SettingAction[] = [
        {
          icon: IconEye,
          label: "Chi tiết",
          tooltip: "Chi tiết",
          onClick: () => {
            this.selectedVatTuId = row.id;
          },
        },
      ];

      if (this.showDeleteButton) {
        actions.push({
          icon: IconTrash,
          label: "Xoá",
          tooltip: "Xoá",
          any: ["data:bbgt:sua"],
          onClick: () => this.$emit("remove", { id_vat_tu: row.id }),
        });
      }

      return actions;
    },

    thanhTienDisplay(index: number) {
      return formatAmount(
        calcLineAmount(
          this.vatTuItems[index].don_gia,
          this.items[index].pivot.so_luong
        )
      );
    },
  },
});
